import useAddressFragment from './AddressFragment';
import usePageInfoFragment from './PageInfoFragment';
import usePhoneNumberFragment from './PhoneNumberFragment';
import useInspirationFragment from './InspirationFragment';
import useConfirmationFragment from './ConfirmationFragment';
import useMeasurementFragment from './MeasurementFragment';

export default () => {
  const { AddressFragment } = useAddressFragment();
  const { PageInfoFragment } = usePageInfoFragment();
  const { PhoneNumberFragment } = usePhoneNumberFragment();
  const { InspirationFragment } = useInspirationFragment();
  const { ConfirmationFragment } = useConfirmationFragment();
  const { ConfirmationReducedFragment } = useConfirmationFragment();
  const { MeasurementFragment } = useMeasurementFragment();

  return {
    AddressFragment,
    PageInfoFragment,
    PhoneNumberFragment,
    InspirationFragment,
    ConfirmationFragment,
    ConfirmationReducedFragment,
    MeasurementFragment,
  };
};
